import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';

import { getVideos } from '../../../redux/modules/video';
import { getOrganizations, getSelectedOrganization } from '../../../redux/modules/organization';

import { VpIcon, VpInfoMenu } from '../..';

const PERSONAL_CONTEXT_LABEL = 'My Account';

const menuItemStyle = {
  padding: '8px 14px',
  fontSize: '1em'
};
const TypoStyles = { padding: '8px 14px' };

export const OrganizationDropdown = ({
  organizationsUserIsMemberOf,
  selectedOrganization,
  onChangeContext,
  _getVideos
}) => {
  const switchContextAndGetVideos = (organizationId) => {
    onChangeContext(organizationId);
    _getVideos();
  };

  if (!organizationsUserIsMemberOf || !organizationsUserIsMemberOf.length) {
    return null;
  }

  const currentContextLabel =
    (selectedOrganization && selectedOrganization.organization.name) || PERSONAL_CONTEXT_LABEL;

  const menuButton = (
    <Stack direction="row" gap="10px" alignItems="center">
      <Typography variant="dropDownText" noWrap>
        {currentContextLabel}
      </Typography>
      <VpIcon icon="ChevronDown" sx={{ width: '14px' }} />
    </Stack>
  );

  return (
    <>
      <VpInfoMenu
        id={currentContextLabel}
        loading={false}
        IconButtonProps={{ sx: { borderRadius: '5px' } }}
        menuButton={menuButton}
      >
        {organizationsUserIsMemberOf.map((organizationInfo) => (
          <Box key={organizationInfo.organization.id}>
            <Typography variant="boldCaption" sx={TypoStyles}>
              {organizationInfo.role.name}
            </Typography>
            <MenuItem
              sx={menuItemStyle}
              onClick={() => switchContextAndGetVideos(organizationInfo.organization.id)}
            >
              {`${organizationInfo.organization.name} ${organizationInfo.role ? '(Shared)' : ''}`}
            </MenuItem>
            <Divider orientation="horizontal" />
          </Box>
        ))}
        <MenuItem sx={menuItemStyle} onClick={() => switchContextAndGetVideos(null)}>
          {PERSONAL_CONTEXT_LABEL}
        </MenuItem>
      </VpInfoMenu>
    </>
  );
};

OrganizationDropdown.propTypes = {
  organizationsUserIsMemberOf: PropTypes.array,
  selectedOrganization: PropTypes.object,
  onChangeContext: PropTypes.func,
  _getVideos: PropTypes.func
};

function mapStateToProps(state) {
  return {
    organizationsUserIsMemberOf: getOrganizations(state),
    selectedOrganization: getSelectedOrganization(state)
  };
}

const mapDispatchToProps = {
  _getVideos: getVideos
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationDropdown);



// WEBPACK FOOTER //
// ./src/vp-ui/components/OrganizationDropdown/index.js